import { FETCH_ACTIVITY, FETCH_ACTIVITY_SUCCESS, FETCH_ACTIVITY_ERROR, FETCH_ACTIVITY_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const FetchActivity = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case FETCH_ACTIVITY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case FETCH_ACTIVITY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case FETCH_ACTIVITY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default FetchActivity;
